import { Ecommerce, EventNamesList, Taxonomy } from './contracts';
import { mapTracking } from './trackEvent';
import { getPageTrackingData } from './getPageTrackingData/getPageTrackingData';
import { mapTraitsToTaxonomy } from './segment/mapTraitsToTaxonomy';

/**
 * Function for triggering Segment tracking with GA events
 * @param {string} eventName - Segment event name
 * @param {object} GAEvent - GA event variables
 * @param {string} page - Page path that used for page tracking
 * @param {object} taxonomy - Extra taxonomy objects
 * @param {object} ecommerce - Extra ecommerce objects
 */
export const trackSegmentAndGAEvent = (
    eventName: EventNamesList,
    GAEvent: {
        eventCategory?: string;
        eventAction?: string;
        eventLabel?: string;
        eventValue?: string;
    },
    page: string,
    taxonomy?: Taxonomy,
    ecommerce?: Ecommerce
) => {
    const pageTrackingData = getPageTrackingData(page, taxonomy, ecommerce);

    const eventData = {
        ...mapTracking(taxonomy, ecommerce),
        ...pageTrackingData,
        eventCategory: GAEvent?.eventCategory,
        eventAction: GAEvent?.eventAction,
        eventLabel: GAEvent?.eventLabel,
        eventValue: GAEvent?.eventValue,
        ga_enabled: true,
        ecommerce_enabled: ecommerce ? true : false
    };

    if (!eventData) return;

    if (typeof window.analytics !== 'undefined') {
        if (eventName === 'Viewed Page' && taxonomy) {
            window.analytics.page(taxonomy.page, eventData);
        }
        window.analytics.ready(() => {
            const traits = window.analytics?.user()?.traits();
            window.analytics?.track(
                eventName,
                {
                    ...eventData,
                    taxonomy: {
                        ...eventData.taxonomy,
                        ...mapTraitsToTaxonomy(traits)
                    }
                },
                { traits }
            );
        });
    }
};
